import { render, staticRenderFns } from "./priceDetail.vue?vue&type=template&id=13eb1693&"
import script from "./priceDetail.vue?vue&type=script&lang=js&"
export * from "./priceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports